import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { HammerIcon, LockKeyIcon } from "@phosphor-icons/react";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-navy-900 flex items-center justify-center px-6 bg-grid">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2 justify-center mb-8">
          <span className="w-10 h-10 rounded-sm bg-gold-600 flex items-center justify-center">
            <HammerIcon size={22} weight="fill" className="text-white" />
          </span>
          <span className="font-heading font-extrabold text-xl text-white">MCC Service Corp. Admin</span>
        </div>
        <form onSubmit={submit} data-testid="admin-login-form" className="bg-white rounded-sm border border-slate-200 p-8 shadow-crisp">
          <div className="flex items-center gap-2 mb-6">
            <LockKeyIcon size={22} weight="duotone" className="text-gold-600" />
            <h1 className="font-heading text-2xl font-bold text-slate-900">Staff Login</h1>
          </div>
          <div className="space-y-4">
            <div>
              <Label className="text-slate-900 font-medium mb-2 block">Email</Label>
              <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com" className="bg-white border-slate-300" />
            </div>
            <div>
              <Label className="text-slate-900 font-medium mb-2 block">Password</Label>
              <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className="bg-white border-slate-300" />
            </div>
          </div>
          <button
            type="submit"
            data-testid="login-submit"
            disabled={loading}
            className="mt-6 w-full rounded-sm bg-gold-600 hover:bg-gold-700 text-white font-semibold px-6 py-3 transition-colors active:scale-95 disabled:opacity-60"
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
        <p className="text-center text-slate-500 text-sm mt-6">
          <a href="/" className="hover:text-gold-500 transition-colors">← Back to site</a>
        </p>
      </div>
    </div>
  );
}
